import PropTypes from "prop-types"
import { Fragment } from "react"
import { connect } from "react-redux"

import { Section, SectionTitle, Text } from "areas/product/jewlr/components"
import { IS_PORTAL } from "helpers/application"
import { cn } from "styles/utils"

const InternalProductDescription = ({ description, specs, styleCode }) => {
  return (
    <Section
      className="tablet:pt-48 desktop:px-32 px-16 pb-24"
      id="product-description"
    >
      <SectionTitle className="mb-18 desktop:mb-10 desktop:text-left text-center">
        DESCRIPTION & DETAILS
      </SectionTitle>

      <div className="desktop:flex-row desktop:gap-40 flex flex-col gap-28">
        {description && (
          <Text
            className={cn(
              "basis-auto",
              IS_PORTAL() ? "desktop:basis-[65%]" : "desktop:basis-[556px]"
            )}
          >
            {description.split("\n").map((line, i) => (
              <Fragment key={`reg-product-${i}`}>
                {line} <br />
              </Fragment>
            ))}
          </Text>
        )}
        <div className="gap-18 grid flex-1 grid-cols-2">
          {specs.map((spec, i) => (
            <div key={`spec${spec.name}${i}`}>
              {spec.component_label && <span>{spec.component_label}</span>}
              <h3 className="text-16 leading-16 mb-2 font-bold capitalize">
                {spec.name}:
              </h3>

              <Text
                dangerouslySetInnerHTML={{
                  __html: spec.value.replace(/\n/g, "<br/>"),
                }}
              />
            </div>
          ))}
          <div>
            <h3 className="text-16 leading-16 mb-2 font-bold capitalize">
              Style Code:
            </h3>
            <Text>{styleCode}</Text>
          </div>
        </div>
      </div>
    </Section>
  )
}

// REFACTOR TODO: should be done in back-end
const stone_spec_string = (wizard_option, selected_value) => {
  var out = wizard_option.stone_size
  if (
    (selected_value == "04DIAM" || selected_value == "04LABDIAM") &&
    wizard_option.diamond_weight
  ) {
    out += ` (${wizard_option.diamond_weight.toFixed(2)} ct tw)`
  }
  return out
}
const specs = (state) => {
  let specs_array = []

  // Add spec for each stone
  Object.keys(state.wizard.data).forEach((pref) => {
    if (
      state.wizard.data[pref].stone_size &&
      state.wizard.data[pref].heading.title &&
      !state.wizard.data[pref].hide_on_pdp_description
    ) {
      let selected_value =
        state.choices && state.choices[pref] ? state.choices[pref].value : null
      specs_array.push({
        name: state.wizard.data[pref].heading.title,
        value: stone_spec_string(state.wizard.data[pref], selected_value),
      })
    }
  })
  specs_array.push(...(state.wizard.description.specs || []))

  // Add extra specs
  Object.keys(state.choices).forEach((pref) => {
    // not show duplicate spec etc JWL0690
    if (pref == "face1" || pref == "face2") {
      return
    }
    let specs = state.choices[pref].specs
    if (specs) {
      specs.forEach((spec) => {
        let spec_data = { name: spec.name, value: spec.value }
        if (
          state.wizard.description.has_face_component_options &&
          state.wizard.data[pref]
        ) {
          Object.assign(spec_data, {
            component_label: state.wizard.data[pref].display_label,
          })
        }
        specs_array.push(spec_data)
      })
    }
  })
  return specs_array
}

const mapStateToProps = (state) => {
  return {
    description: state.wizard.description.product_description,
    details: state.wizard.description,
    specs: specs(state),
    styleCode: state.choices?.style_code?.value,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalProductDescription.propTypes = {
  description: PropTypes.string,
  details: PropTypes.object,
  specs: PropTypes.array,
  styleCode: PropTypes.string,
}

const ProductDescription = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalProductDescription)

export default ProductDescription
